// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { JsonValueSchema } from '../inputTypeSchemas/JsonValueSchema'

/////////////////////////////////////////
// OPEN API SCHEMA
/////////////////////////////////////////

export const OpenApiSchema = z.object({
  id: z.string(),
  tenantId: z.string().nullable(),
  applicationId: z.string(),
  applicationFileId: z.string(),
  spec: JsonValueSchema,
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type OpenApi = z.infer<typeof OpenApiSchema>

export default OpenApiSchema;
